import React from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import logo1 from "../../assets/logo1.png";
const Navbar = () => {
  return (
    <div className="navbar">
      {/* Left side */}
      <div className="navbar-left">
        <div className="logo-circleee">
           <img src={logo1} alt="logo-zikrme" className="zikrme-logo-image"/>
        </div>
        <h2>What we get</h2>
      </div>

      {/* Right side */}
      <div className="navbar-right">
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/contact">Contact</Link>

        <div className="search-box">
          <input type="text" placeholder="Search in site" />
          <FiSearch className="search-icon" />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
